import React from 'react';
import { CommonAttachment } from '../general/attachment';

export const Attachment = ({ attachment }) => {
    return (
        <CommonAttachment attachment={attachment} />
    );
};
